"use strict";function KeySequence() {
  this.aQ_ = Object.create(null);
}

KeySequence.prototype.aN_ = function (key) {
  var lookup = this.aQ_;

  if (lookup[key]) {
    return key + "_" + lookup[key]++;
  }

  lookup[key] = 1;
  return key;
};

module.exports = KeySequence;